<template>
    <v-container>
        <span class="specimen-details-header">Weight History</span>
        <v-data-table
            :headers="headers"
            :items="history"
            :sort-by.sync="pagination.sortBy"
            :sort-desc.sync="pagination.sortDesc"
            :items-per-page.sync="pagination.rowsPerPage"
            :page.sync="pagination.page"
        >
            <template v-slot:item="props">
                <tr>
                    <td>{{formatHusbandryDate(props.item.HusbandryDate)}}</td>
                    <td>{{props.item.Weight}}</td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import constants from 'comunet-btg-utah-repository-shared/constants';

import moment from 'moment';

export default {
    props: {
        // eslint-disable-next-line vue/require-default-prop
        history: Array
    },
    data() {
        return {
            headers: [
                {
                    text: "Date",
                    value: "SortDate"
                },
                {
                    text: "Weight",
                    value: "Weight"
                }
            ],
            pagination: {
                descending: true,
                sortBy: "SortDate",
                rowsPerPage: 10,
                page: 1
            }
        }
    },
    methods: {
        formatHusbandryDate(date) {
             if (date.includes("Weight")){
                return date;
            }
            if (!date){
                return "No clean recorded";
            } else {
                return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
            }
        },
    }
}
</script>